/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="37" fill="none" {...props}>
    <title>Android Logo</title>
    <g clipPath="url(#A)">
      <path
        fillRule="evenodd"
        d="M20.363 7.315c-.603 0-1.091-.475-1.091-1.062s.488-1.06 1.091-1.06 1.091.473 1.091 1.06-.488 1.062-1.091 1.062zm-8.727 0c-.603 0-1.091-.475-1.091-1.062s.488-1.06 1.091-1.06 1.091.473 1.091 1.06-.488 1.062-1.091 1.062zm9.372-4.253l.406-.598.407-.589.906-1.325c.113-.163.066-.383-.102-.49s-.393-.065-.502.099l-1.383 2.015-.415.606c-1.315-.497-2.779-.774-4.326-.774s-3.011.277-4.326.774l-.413-.606-.409-.596L9.88.159c-.113-.163-.338-.206-.506-.099a.35.35 0 0 0-.102.49l.906 1.325.406.589.409.598c-3.086 1.4-5.174 4.051-5.174 7.085h20.361c0-3.034-2.088-5.685-5.172-7.085zm-15.032 8.5h-.157v15.572c0 1.236 1.032 2.243 2.304 2.243h1.661c-.057.187-.088.383-.088.589v4.483c0 1.172.979 2.122 2.183 2.122s2.183-.95 2.183-2.122v-4.483a2.07 2.07 0 0 0-.088-.589h4.052a2.07 2.07 0 0 0-.086.589v4.483c0 1.172.976 2.122 2.181 2.122s2.185-.95 2.185-2.122v-4.483c0-.206-.033-.402-.09-.589h1.664c1.273 0 2.302-1.006 2.302-2.243V11.562H5.976zm-3.793 0c-1.206 0-2.183.95-2.183 2.122v9.085c0 1.172.977 2.122 2.183 2.122s2.181-.95 2.181-2.122v-9.085c0-1.172-.977-2.122-2.181-2.122zm27.637 0c-1.206 0-2.183.95-2.183 2.122v9.085c0 1.172.976 2.122 2.183 2.122S32 23.941 32 22.769v-9.085c0-1.172-.977-2.122-2.181-2.122z"
      />
    </g>
    <defs>
      <clipPath id="A">
        <path d="M0 0h32v36.571H0z" />
      </clipPath>
    </defs>
  </svg>
);
